import { render, staticRenderFns } from "./Beatmung.vue?vue&type=template&id=be722190&scoped=true"
import script from "./Beatmung.vue?vue&type=script&lang=js"
export * from "./Beatmung.vue?vue&type=script&lang=js"
import style0 from "./Beatmung.vue?vue&type=style&index=0&id=be722190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be722190",
  null
  
)

/* custom blocks */
import block0 from "./Beatmung.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports